<template>
  <keep-alive>
    <div class="wrap-apn-list">
      <div class="response_table">
        <table>
          <thead
            ref="tableHead"
            class="table-apn-list_bg"
          >
            <tr>
              <th
                  class="pointer w100"
                  @click="change_filter('is_active')"
                  :class="{ selected: filter_type === 'is_active' }"
                  scope="col"
              >
                {{ translate('apn_list.status') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer w100"
                  @click="change_filter('device_count')"
                  :class="{ selected: filter_type === 'device_count' }"
                  scope="col"
              >
                {{ translate('apn_list.devices') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer w100"
                  @click="change_filter('mno_name')"
                  :class="{ selected: filter_type === 'mno_name' }"
                  scope="col"
              >
                {{ translate('apn_list.mno_name') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th
                  class="pointer"
                  @click="change_filter('apn')"
                  :class="{ selected: filter_type === 'apn' }"
                  scope="col"
              >
                {{ translate('apn_list.apn') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>

              <th scope="col">
                {{ translate('apn_list.oper_account') }}
              </th>

              <th scope="col">
                {{ translate('apn_list.network_access_type') }}
              </th>

              <th scope="col">
                {{ translate('apn_list.device_apn_mode') }}
              </th>

              <th scope="col">
                {{ translate('apn_list.ip_networks') }}
              </th>

              <th scope="col">
                {{ translate('apn_list.provisioning_mode') }}
              </th>

              <th scope="col">
                {{ translate('apn_list.client_names') }}
              </th>

              <th scope="col">
                {{ translate('apn_list.comment') }}
              </th>

              <th scope="col">
                {{ translate('apn_list.params') }}
              </th>

              <th
                  class="pointer"
                  @click="change_filter('ts_create')"
                  :class="{ selected: filter_type === 'ts_create' }"
                  scope="col"
              >
                {{ translate('apn_list.ts_create') }}
                <i class="mdi mdi-arrow-down" :class="{ reverse: filter_asc === 'desc' }"/>
              </th>
              <th style="width: 7px" />
            </tr>
          </thead>

          <tbody ref="tableSimcard">
            <tr v-if="load">
              <td> <scale-loader /> </td>
            </tr>

            <ApnListItem
              v-for="(item,index) in apn_list_comp"
              class="apn_item"
              :key="index"
              :index="index"
              :item="item"
            />
          </tbody>
        </table>
      </div>
    </div>
  </keep-alive>
</template>
<script>

import ApnListItem from './Item/Index.vue'
import TagListPopup from 'components/UIComponents/Tags/TagListPopup.vue'

export default {
  name: 'ApnList',
  components: {
    ApnListItem,
    TagListPopup
  },
  data () {
    return {
      filter: {},
      load: true,
      afterload: false,
      apn_list: [],
      filter_asc: "asc",
      filter_type: "",
    }
  },

  computed:{
    apn_list_comp(){
      let apn_list_comp = [...this.apn_list];
      return apn_list_comp.sort(this.compareNumbers);
    },
  },

  watch:{
    filter:{
      deep: true,
      handler(){
        this.load_apn_list()
      }
    }
  },

  created () {
    this.load_apn_list()
  },

  methods: {
    load_apn_list(){
      this.load = true
      this.$http.simcard.getSimcardOperatorApn({}, (response) => {
        if (response.data){
          this.load = false
          this.apn_list = response.data
        }else{
          this.global_notify('danger', this.translate('no_data'))
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.wrap-apn-list{
  display: flex;
  flex-direction: column;
  height: 100%;
  .response_table{
    padding: 0;
    th{
      font-size: 12px;
    }
  }
}

</style>
